import { Step } from 'modules/processes/domain'

const AFTER = 'after'
const BEFORE = 'before'

export interface StepFormValues {
  name: string
  before_or_after: string
  step_to_swap_id: number
  offset_direction: string
  offset_amount: number
}

const buildStepData = (step: Step, position: number) => {
  // eslint-disable-next-line no-type-assertion/no-type-assertion
  return {
    ...step,
    position,
  } as Step
}

export const buildStepsWithPositionsForCreateAction = (steps: Step[], values: StepFormValues) => {
  const { before_or_after: beforeOrAfter, step_to_swap_id: stepToSwapId } = values
  let position = 1
  let newStepPosition = 1
  const stepsToBeUpdated: Step[] = []
  const stepToSwapIndex = steps.findIndex((step) => step.id === +stepToSwapId)

  // For each steps
  //    -> if step is not a candidate for replacement, assign position and push to the list of stepsToBeUpdated
  //    -> If step is a candidate for replacement
  //      ---> When the direction for new step is BEFORE
  //           ---> assign the currrent positon to the new step
  //           ---> increament position by 1
  //           ---> assign the new position to this step and push to the list of stepsToBeUpdated
  //
  //       --->  When the direction for new step is AFTER
  //           ---> assign position to this step and push to the list of stepsToBeUpdated
  //           ---> increament position by 1
  //           ---> assign the new position to the new step
  //
  //       ---> increament position by 1

  steps.forEach((step, index) => {
    if (!(stepToSwapIndex === index)) {
      stepsToBeUpdated.push(buildStepData(step, position))
      position += 1
      return
    }

    if (beforeOrAfter === BEFORE) {
      newStepPosition = position
      position += 1
      stepsToBeUpdated.push(buildStepData(step, position))
    }

    if (beforeOrAfter === AFTER) {
      stepsToBeUpdated.push(buildStepData(step, position))
      position += 1
      newStepPosition = position
    }
    position += 1
  })
  return {
    stepsToBeUpdated,
    newStepPosition,
  }
}

export const buildStepsWithPositionsForUpdateAction = (
  steps: Step[],
  currentStep: Step,
  values: StepFormValues
) => {
  const { before_or_after: beforeOrAfter, step_to_swap_id: stepToSwapId } = values

  let position = 1
  // return the current step as stepsToBeUpdated when you have only one item to be re-arranged
  if (steps.length === 1) return [buildStepData(currentStep, position)]

  const stepsToBeUpdated: Step[] = []
  // remove the current step from the list
  const stepsToSwap = steps.filter((step) => step.id !== currentStep?.id)
  const stepToSwapIndex = stepsToSwap.findIndex((step) => step.id === +stepToSwapId)

  // For each steps
  //    -> if step is not a candidate for replacement, assign position and push to the list of stepsToBeUpdated
  //    -> If step is a candidate for replacement
  //      ---> When the direction for new step is BEFORE
  //           ---> assign the currrent positon to the current step we are updating
  //           ---> increament position by 1
  //           ---> assign the new position to this step and push to the list of stepsToBeUpdated
  //
  //       --->  When the direction for new step is AFTER
  //           ---> assign position to this step and push to the list of stepsToBeUpdated
  //           ---> increament position by 1
  //           ---> assign the currrent positon to the current step we are updating
  //
  //       ---> increament position by 1

  stepsToSwap.forEach((step, index) => {
    if (!(stepToSwapIndex === index)) {
      stepsToBeUpdated.push(buildStepData(step, position))
      position += 1
      return
    }

    if (beforeOrAfter === BEFORE) {
      stepsToBeUpdated.push(buildStepData(currentStep, position))
      position += 1
      stepsToBeUpdated.push(buildStepData(step, position))
    }

    if (beforeOrAfter === AFTER) {
      stepsToBeUpdated.push(buildStepData(step, position))
      position += 1
      stepsToBeUpdated.push(buildStepData(currentStep, position))
    }

    position += 1
  })
  return stepsToBeUpdated
}
